export const pushToGTM = (eventName: string, eventParams: any) => {
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  // @ts-ignore
  window.dataLayer.push({
    event: eventName,
    ...eventParams,
  });
};
